import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueGtag from 'vue-gtag'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/js/bootstrap.min'

createApp(App)
.use(router)
.use(VueAxios, axios)
.use(VueGtag, {
    appName : 'AMS-WEB-COMPRO',
    config : { 
        id : process.env.VUE_APP_MEASUREMENT_ID, 
        params: {
            anonymize_ip: true
        }
    }
}, router)
.mount('#app')
